import { render, staticRenderFns } from "./topUpList.vue?vue&type=template&id=bbf1dd90&scoped=true"
import script from "./topUpList.vue?vue&type=script&lang=js"
export * from "./topUpList.vue?vue&type=script&lang=js"
import style0 from "./topUpList.vue?vue&type=style&index=0&id=bbf1dd90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf1dd90",
  null
  
)

export default component.exports